<template>
  <div class="shop-wrapper" :style="{ backgroundImage: 'url(' + require(`../../assets/images/butlers/background.png`) + ')' }">
    <div class="container">
      <div class="shop">
        <div class="shop-image">
          <img :src="require(`../../assets/images/butlers/butlers.png`)">
        </div>

        <div class="shop-mint">
          <template v-if="!isPublicSaleStarted" >
            <h2 class="section__title section__title--lg text-center" style="justify-content: center">{{$t("mint.publicmint")}}<br>{{$t("mint.countdown")}}</h2>
            <countdown-timer :end-time-in-unixtime="publicSaleStartTime">
                <template v-slot="slotProps">
                    <div class="maid-sale-countdown"> 
                        <div class="maid-sale-countdown__group">
                            <span class="maid-sale-countdown__num">{{ slotProps.times[0].time }}</span>
                            <span class="maid-sale-countdown__unit">{{$t("mint.unit.day")}}</span>
                        </div>
                        <div class="maid-sale-countdown__group">
                            <span class="maid-sale-countdown__num">{{ slotProps.times[1].time }}</span>
                            <span class="maid-sale-countdown__unit">{{$t("mint.unit.hour")}}</span>
                        </div>
                        <div class="maid-sale-countdown__group">
                            <span class="maid-sale-countdown__num">{{ slotProps.times[2].time }}</span>
                            <span class="maid-sale-countdown__unit">{{$t("mint.unit.minute")}}</span>
                        </div>
                        <div class="maid-sale-countdown__group">
                            <span class="maid-sale-countdown__num">{{ slotProps.times[3].time }}</span>
                            <span class="maid-sale-countdown__unit">{{$t("mint.unit.second")}}</span>
                        </div>
                    </div>
                </template>
            </countdown-timer>
          </template>

          <template v-else >
            <h2 class="section__title section__title--lg text-center" style="justify-content: center">{{$t("mint.publicLive")}}</h2>
          </template>

          <p v-if="!isWhitelisted && !isPublicSaleStarted" class="whitelist-desc">
            <template v-if="isWhitelistSaleStarted">{{$t("mint.whitelistmintOpened")}}<br></template> 
            <template v-else>{{$t("mint.whitelistmintDate")}}<br></template> 

            <template v-if="!linkAddress">{{$t("mint.connectDesc")}}<br></template> 
            <template v-else>{{$t("mint.notInWhitelist")}}<br></template> 
            {{$t("mint.whitelistGiveaway")}} <a target="_blank" href="https://discord.gg/KaEE4cVwDF">Discord</a>
          </p>

          <p v-else-if="isWhitelisted && !isPublicSaleStarted" class="whitelist-desc">
             {{$t("mint.yesInWhitelist")}} <br> 
            <!-- You are getting 0.01ETH discount🎉<br> -->
            <template v-if="isWhitelistSaleStarted">{{$t("mint.whitelistmintOpened")}}<br></template> 
            <template v-else>{{$t("mint.whitelistmintDate")}}<br></template> 
          </p>

          <div v-else class="whitelist-desc" style="max-width: 380px; margin: 0 auto">
            {{$t("mint.japanNft")}}🎉🎉🎉
          </div>

          <template v-if="isWhitelistSaleStarted">
            <template v-if="!isSoldOut">
              <div class="mint-number-wrapper">
                <div @click="reduceNum('public')" class="mint-number-btn">-</div>
                <div class="mint-number">{{ mintNum }}</div>
                <div @click="addNum('public')" class="mint-number-btn">+</div>
              </div>

              <div class="mint-price">
                Total {{ (mintNum * price).toFixed(2) }} eth  [ {{ currentCount || 0 }} / {{ maxSupply }} ]
              </div>

              <div class="mint-btn-wrapper">
                <span v-if="!linkAddress" @click="linkSetup" class="mint-btn r-mint">{{$t("mint.connectImx")}}<br></span>
                <span v-else-if="(isPublicSaleStarted || (isWhitelisted && isWhitelistSaleStarted))" @click="mint" class="mint-btn r-mint">{{$t("mint.mintBtn")}}</span>
              </div>
              <p class="mint-caution">
                <span v-if="linkAddress">Immutable X: {{ linkAddress }}</span><br>
                {{$t("mint.maximum")}} <br>
                {{$t("mint.check")}} <br><a href="https://market.x.immutable.com/assets?collection=0x177c23722581262d2f76a419c4a4e9963dcf70ca" target="_blank" style="border-bottom: 1px solid #fff">the Immutable X marketplace→</a>
              </p>
            </template>
            <template v-else>
              <div class="mint-btn-wrapper">
                <a class="mint-btn r-mint" href="https://market.x.immutable.com/assets?collection=0x177c23722581262d2f76a419c4a4e9963dcf70ca" target="_blank" style="border-bottom: 1px solid #fff">
                  IMX Marketplace
                </a>
              </div>   
            </template>
          </template>

          <template v-else>
            <template v-if="!isSoldOut">
              <div class="mint-btn-wrapper">
                <span v-if="!linkAddress" @click="linkSetup" class="mint-btn r-mint">{{$t("mint.connectImx")}}</span>
              </div>
              <p class="mint-caution">
                <span v-if="linkAddress">Immutable X: {{ linkAddress }}</span><br>
                {{$t("mint.maximum")}} <br>
                {{$t("mint.check")}} <br><a href="https://market.x.immutable.com/assets?collection=0x177c23722581262d2f76a419c4a4e9963dcf70ca" target="_blank" style="border-bottom: 1px solid #fff">the Immutable X marketplace</a>
              </p>
            </template>
            <template v-else>
              <div class="" style="text-align: center;font-weight: 600;font-size: 20px;color: lightseagreen; justify-content: center;">
                {{$t("mint.soldout")}}
              </div>
              <div class="mint-btn-wrapper">
                <a class="mint-btn r-mint" href="https://market.x.immutable.com/assets?collection=0x177c23722581262d2f76a419c4a4e9963dcf70ca" target="_blank" style="border-bottom: 1px solid #fff">
                  Purchase at the Immutable X marketplace
                </a>
              </div>   
            </template>
          </template>


          <!-- <div>
            railsEnvironment: {{ railsEnvironment }} <br>
            walletAddress: {{ walletAddress }} <br>
            whitelist: {{ whitelist }} <br>
            whitelist: {{ lcaseWhitelist }} <br>
            mintNum: {{ mintNum }} <br>
            whitelistMintNum: {{ whitelistMintNum }} <br>
            whitelistSaleStartTime: {{ whitelistSaleStartTime }} <br>
            isWhitelisted: {{ isWhitelisted }} <br>
            isWhitelistSaleStarted: {{ isWhitelistSaleStarted }} <br>
            isPublicSaleStarted: {{ isPublicSaleStarted }} <br>
            publicSaleStartTime: {{ publicSaleStartTime }} <br>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'packs/axios'
import isMobile from "ismobilejs";
import { ethers } from "ethers";
import ButlersAbi from 'abi/butlers.json';
import CountdownTimer from "packs/components/utility/countdown-timer.vue";
import { Link, ImmutableXClient, ImmutableMethodResults} from '@imtbl/imx-sdk';
export default {
  components: {
    CountdownTimer
  },
  data: function() {
    return {
      intervalId: undefined,
      isMobile,
      // contract
      contractAddressForDevelopment: "0x8f0c2E46B76a093fBD513823eA8ad3D67d79f6F9",
      contractAddress: "0x177C23722581262d2f76a419c4A4E9963DcF70cA",
      contractAbi: ButlersAbi,
  
      // data
      railsEnvironment: "production",
      walletAddress: "",
      whitelist: ["0xA3dd82dDb3A453A5DBF205322F3E11c42099ac1e","0x244FD2293e355db7EB0b1Cae86fC70e05A3bE189","0x67CE48Cc5D2602B070f21ecF728B00031AFE9b24","0xdb3396542432A223F103527Cb987d560dB90112e","0x33540B50214D1162b64a356699c17e6bb172e6eE","0xe3a6144927ac57c6f17d33fb9ad53d56573c13a3","0x70803312AdD097966D93F35d122F33BbCa021Fe5","0xA2b6ee221Ba7beb1A949FB18562e49020BE168Fc","0x9763771312dfED5BD8F14c224626be2aF6c4102A","0x14d76dD2de872ca66075058088e7B13931b0141C","0x57f1b7D288ef37E75900B64578EAe542bAf19A06","0x82Df9620224dc2491252c7d699C2515BD1d433A0","0x082dE924d8b13Fa620387B342d88B35B07BC2d6e","0xc9539907071b39B2fde758E41106338F29f46559","0x654d556ab8104da43aba8ef8592691967d7f1c28","0x31c3ab08791313e7763bF53054B0cBD751aD388D","0xAE0404EFb897Cdd812eF47deFEA0d675760D9bE1","0x0F8B860e765143C9A661392E533C65612C238e06","0xBb2741E75DC07C9ca11a297A9Ca73C6F214F769d","0xD1CcBca4294b35BEce5E61739FE9E41540Dec415","0x2f8Eb05a21d212a129951f0925174D32D24aE785","0x1aaf1e050751ae03534a4a44d6604964f5acdc31","0xda6711e123038d93edde6e38003b37c69c64707b","0xD5CF7c8E66198ac98D1207065feD1Af88CE990AB","0x9bA0f838c13B62cE6e82662Bdc0a3B8fB4D4866D","0x242369Ac7b53561fC289f2030281A0B3378c830E","0xfA8ed8ca95b89214a0298B3e100eBbA3DBd44879","0x9665c29812BCB0Ef058E83f50E911931a1784C98","0x7880736C7B21131EfDC989DB3aFEDf98cd74B638","0xa1468fC8E25648f07b8B3a854AeA0C08996eFAD8","0x18A6f239E133b04A7089A280Bf48cc84ccca0622","0x02b7ddb4b20544e8f84b798e8d8d9f385ea2de7d","0xad41acb27f9574996e8712270114b1b16aadffce","0xaC8A729D4df6B995c15C0be25D7c9C74752Fd899","0x896f4C3876F036829008c19D8D5FE97Cc0b8C749","0x06c899b03978F252cbD39b8C08cDa30cEBA8C9D6","0x611F70962f9f024F55aB38f15186cB7Bfc6239ae","0x34D05a19897DCF48DE4b4f97F63563A19c816EF5","0x959Ae70CC7d1a3d0f6BEEb10075fE6DdD266a170","0x04eF01Ae4D27CAFeE75fE0BC8b575c6877287399","0x257434990898a303e2Fb458d1a46b68CDc47754b","0x65171d4a2f107a84C1E4DD174488c82A76888702","0x829a835591ab53B4b29b474B123a41d820DAE91e","0x0C0c1f32f0844d7e51ADcE68cd625d39B525A4FD","0x0b018892335bF2E67B14bA7B8b37f821cdA43dB8","0xD1F43D3c0Ea2899b66Ee713D86197BcbadfAdc46","0x0C688f562012E7ECEDD087C08d6998E7d2Ea82c6","0x419fD53f8c5c957Ae2c52A7df6904e986E59db62","0x15D2C72586EdE1da8a0f104E467Ac515E02bE98C","0xDDf977542BFF0350DC35052530Da21a2762257C4","0xD9ACa0B3A35a9bD5c2575535465d9Ec9C9C8b278","0xF86Aa1b8eE7ab40945050181c12f1B2F3c1D9798","0xcF493A90Fdd9aa8dDdad3Eb0821Ede686ad9761B","0xe6099b8b93c53ff17913f0b1ed134ca674ef98c4","0xf02074DC23194541EEecbc7068865e93B84B92D2","0x81871680D8CFcF5a6958E1a59639e987b0210494","0x261A2f9C13b073aA56E0b49000Ecb96CEBfc3a4f","0xe5919152A8880Ba3F39A1b8787B82261bBde4471","0xF98717C8dC62F1F24D02Effc27eeF35968247236","0x7f0D22F0F7029FCe90E4Fc7675C0284C64253C76","0x47cE85f1508C66Fb2a975663f18946d691F9679C","0x05E5B530DEdb76BbCb7d5354d5992846199c68D1","0x8336cD8995b1bF5F2BDdF8052Efa4e726c2d8Cd0","0xA3cC4B0b47F17c78E19419a71DD978985a23e38C","0xfb00bd2be771716222f9f7bbac28972d03a6439f","0x14Eee6fA252c5107Cd75461A0Bc4c827f4aB2Ff9","0x10116eFD549aBb325a5C384f4648f0c7777CFB39","0x1d49510a59D8D1e9f1e2F30225C9a4F10B37cd17","0x0eD633f77AcFec5a97FBdcaFe14fE03c3011D1A2","0x403a66B8aB4715093831CB357f2569597798F3bA","0xF5A4b1Ae0F14C8F6c4D02739E76044FCddc65a26","0x5cb9160Bc86cBB441E143D1b5F1B46a2673716F5","0x0dE9B1D8D29084877836c46246170c84a99968eF","0x69730eE92AaA2e45AFFC46a0a40e272EbABA78D6","0xE2cBDf710968b60bc04e81A73B7546e3521B76CF","0x39A022b58Ed040693A3BA800fED0a0DbA422Cc83","0x81C75227e08E2C4766439Ab51bEa9baBCfCf5edB","0x81208D87db9A7eC9BF6b24D74989485bcC3aAC81","0x5311aFa8F85883c0Ef3619006927aC8073AE30d1","0x2928ad4479b9936eA7D67BeaB7676e0228Cc72D3","0xc4ae8AE68e1D97845CD11970F65249916BC84eCE","0xE427161C8dC169967B6E45AB62eA3Ed3725b1c02","0x0A1dAC1C3B9136bD120FDdFb28aeB084d9C9C42d","0xe85f663217434D8E3499586Ed52E593BA4e05129","0x339722a8fed49071163e7a617D34e7700cDe02fC","0x2F56599Bc41eb460CbC3E2605b1e81C7251d26c5","0x9182Fb826Df1e13DE3Dbe37b09992cF328e64b0e","0xdB091d5184226CFb97DDFc8Bd2c5aace08Dfd8aD","0x863C3Eeeb5C6a80bb4CE6b153CC813c4744A96B7","0x977338fA4C3ac5021727e2c741F57bd34F50a78F","0x0309296c786D5Ca6e0D4e2768cC0adBDb2BD4243","0x05932a0406816e55d1e103659087763791263528","0x064E3D6eEcb4d06770d0A45de0E15178e02657AD","0xf6Cb0cdDD3f62a61BBA9b7BB4ed878b9b546772C","0xcf00b38449A4b75B54c4DF7A2EEABEcEb5c0A5aE","0xCCec8a630eC2c4de68816EE5B4093030317e5386","0x873d85542ed7962b699ca2b976d4cc131883adb2","0x68FCCddD35D6080019C1580F6Ee7987832B734aA","0x90b54cfeF6e210061Bc3A1D38B0582a6ca764Dc4","0x589DEdccE5A7D7D190657138c903B4fe7e97cb50","0x0A633935262518C8F4bDCCCE0aecFfeDBB1E88D7","0x51b3b6Ca661F88564666e35081745543DE87ACf3","0xF4bA68556319cCcfe2Ce2C10E7c5B8B5066CfDbc","0xf5339a9357d2a114c530a1229b9A713d374b39d5","0x64B602d0F8e1301a1D82Aa888c6452EdDaA8f176","0x2E000C18324F39A11Bf07B3BD64ba743EBd5c16b","0x25f2840F40a0cB1935C3250148B0b2Bd3DD45277","0xa8ea8D0B0b625F7df1218d2739f1fb35D3C77E59","0xd52E75f609b77B6b62C205aCC89E3b442aFAE06E","0x153d0b424567D1bf2295D168DC53fAD6FF07d11E","0x70a1827D74317b2BdE76E9d515B85334db47796f","0xEd410226002D5De7fd4B30E4D9607AC1441e7b3a","0x79715414338E05350352BAf1eEbf686720cFEF06","0x9d47E986403eA38e672A44968a848761A281C6f0","0xb7cc944b93eA5FD6bBa02810c855B64a1c29eDf5","0xB82A375CaD4CB13c01D57cDE55887aEB8b49C6EF","0xB04Cc187C2A437DDFf1cA3C242D57F0642518f68","0x76487D414633a8372811D2A2477D44aA3D8780Ab","0x910b6ffE4ef3D483Ad0BA9a4c485DB12E4657498","0x4B850E08F2fb6f134E2CEfC4A5Ab1eE42C9bd4E2","0x7d352658b7fEC49AFECAe3EB8DEbfD0B0Fc82Bb1","0x6eA576e1Bb2c3Cb021742dA5Ca42e035224Fa41F","0x6EcEFE1287F3f2e9aDbDbCb279e74c57Dc2592cd","0x3D4fC943f100A2d409A96e0c9DA39c25552Edf40","0xB7FBa21b52322e20D46292B6aA032F0E0D306bf7","0x7F8A94e621EFae7F5d79124A36B533eAC897c7CF","0xEa29f6C9108409586e7dDB4Ad94E93649FA75943","0x41496F79a2A56f87abaCA41F52c413C4fF8e4Ff2","0xF5E7E46C8145C1F33125b7567D4b93E846d21082","0x2b194BD4Ab9046a54D40919E49990C47Dce5906D","0x78070B74F0c05b2bfEAd4c16565C7AA08EF26868","0x0a2779CdDeb46789B8550d0C6a7FD6aabc293bB1","0x6566567eB9cE9Bf8cd64eD27989c380bF7F61bE5","0x149Fd2056b0b85D33BF600A53bD4151C9e9aFd94","0x9041d01D797969b828ECe248296bf521e14921F4","0xC4d7A04c2539638C0a08930839A4fC09A5cAdceF","0x09D527f07a8B50F80D75aeF7aEF8981f747583F7","0x86cBfc0279C38C2fC97D184De9c1d24F6ab01763","0xc54F1caFfbe7BE1099513E64077F2EE43d3a3D9F","0x3d3B69457Ce7e7998f19e85E018B5a296Aed781e","0x6990e048663a1A50E5dEA565C6B391e27e157eEe","0x96166c840B579D23bD39F0525B5032646450b8C3","0x550406233334E5561514A8A2961609CCeb370D9b","0xa94AEF908dc2222f662cb0A41D84d715C78A2644","0x0f92205deaf7fe765afeba09df667ce428940e6e","0xBFCC69f48981B06998E30d17Be99a801e2cb9e14","0x511eEc9e081a868D4021624A8c6645F2C64A8042","0xB902DFE6bd8aEe747f0A2218Aca57C274a651B87","0x50f8CC2602745193782b74831CE1ea04625d371B","0x207f9Cfa0FE970d6f954d63c79c52b3cB00c00A7","0x5Ea2d0d255D57E25a7193267aC4adDc5ead7ca1d","0x38f048d3b9470ca7c83ac2ea8a6841542e2efdea","0x7a7235e946b83213739950de0a71cac7651b0c36","0xB2F456886367c8e50566377ec6d9293D4Da5bb81","0x006691905b8475b143BB6da551651CfF18f12f09","0xE06F1FEc8dd6f39BA67e7d03E9e57C03354d8b3d","0xe32b8238bca33a3Cd019C69e27942f2E78B46BCc","0x66DC2CCcd7fa6206617A8bDeE3fB6dc21b848A3a","0xD29126e4235551006331437DE4574a2F2BDc840d","0x4899c161BF167bd234e55CEF0810e38386E546BA","0x2b2A2e61E2F848bDee1bdDa600e3E3eCf38b38e2","0xEaB6A32834886DFd8Bb20083F9Fd14E07F72a0d6","0x16C8eAf1E8eDFcd719c18DB056b7F902Ed80e520","0xab937385ABf124aDE6edC93c7e2990f62F1ea0bB","0xB82A375CaD4CB13c01D57cDE55887aEB8b49C6EF","0xE24D5d9Ecc93F37B9Ea170500A509301C4f531fE","0x3c902D2211e392665c74B0071ff5a5e5e83Bf427","0x8F9a3e0f1902D1F75B93b1C167Bc09603399700d","0x44a09272b8A2d2C0EcbeB8EbBb632eA88cAFEb5B","0x93461223024B664047307Dee9f84C2C5A8407855","0x06BAc69D925002B5B1e5553b8C20f997144905c0","0xf54607b7c8d9290b96bb9ff21e28ef4fbba3fec8","0xf207055328D9Bcea17e1653393Dc211Fc28C269f","0x26848a9D7E69C020d2B8732A090Abc927147C8B0","0x97c9Ca12a12c288e767E2506F91C126113deF8b4","0x3ABA7f1A35EEd304C53afa44912c3AF06b01092e","0x18Edf908f1f3C1FbcF1023F081ed988f2fe6cECc","0x12Cce0CcfAF2FA34486336652E2056E464B915Af","0xEa29f6C9108409586e7dDB4Ad94E93649FA75943","0x06f6B5121522773E96625A2D039B2CebEaade9A2","0x169434060E57663650b3e291c9ac1408E1E4C0E5","0x21DBa1ef6113cd2563AFe88713FF14b6351E901E","0xB617f6348E5DBba03F0F100750C371166fc1356d","0x11F262d4154f7860dA5E4F595778087eb7434BCe","0x97E18713C64F75b5c4c6B51b7AB4495c357Db543","0xde88f9D709300AA9F6403Ec8875C053106349315","0x34c2b83f0fe192aff0f00588556e56b09d4b5f26","0x46783E47ba77781D1f29272Be9f1A6Daa14E4c1f","0x55b73A303050E4C9C7A6fE484CF5c0A83D224897","0x7799691a9aA4981a5Fc5fD6E547EB6a90806f9F2","0x5cA2CcB0A103821195b3d1712a7941A2aB89e58f","0xBf8f5127b727da45a8884cCDa06bC43EAf5c8E4c","0x41D0252E42c0eabB41514e8b617B6C914b3BAEC8","0x2c6ce3365858f1d8182edf9e2a26a10ca55279c8","0x5bb8d3cCd40905Ef571Eb456f56856250c3acCfb","0x10455d2469b5235F95C2512026307bD77b1511d2","0x24e212aed0ff1e428e9863529b6a53438924173b","0x3079FC3CC832F99a22d837976062073944dAaa0A","0x5cEc6cD1cAE0625EEF31546Bec61903c9E92afBc","0xd6BE9c8A059a4F13B543f9B91BbD27fE26349c51","0x427fBf978502281929b73f6E187B488646e68D2A","0x307F82560d5FD70858367887e6D9E161d3991509","0x663e55Bf14592812009887f1C38C1f20f46A981e","0xba4e9c7099fd7f8BD390EFA70a49FBDBAE412197","0xE3Ba9817158bd0a935f85cC6ae6dFDaF708886de","0x5a84ff45A6400dD3c203317Bb1a2Ac6CE78C4D9F","0x3296B13B1eE66D953d4449BD81581a4612ECc27F","0x5Ab36C381B35636F60bA2b45b2b428BA0c0732F4","0x2B8146071D1048b90Ead67bdE2AbBd330600B9dB","0x3a073786496C1eC2FD5e10aA08E98Df6C06f90DB","0x22daB38469579525AbD7cB4E2D54Cc7Bd3507298","0x2AEb73C97190C0329718C0AA72509c4797a10C0C","0x1b9C5E4FF930BBCE6A1B9627BC0570E454Aa7E1f","0x6E3BC51810AA3407463bbf2b094BB91EEb91D918","0x3cB1010156174b71dD6f8402C56BA8945F37Bb2C","0x2b586eF27D4f255dfA864e0F0eCf790e54Bd2946","0x109E58Bf171a19dDc0d0b9E4B37BfA72E626873E","0x0384fA1df01F7a9377aEb665EcBb564C18c7f920","0x1cEa7d8Cf909FF8B08D9c69c7f6c9fb010C9a78b","0x8Bc4fB84aCaEEa45aDD0b8D94047f64a59f97ffe", "0x6c26a803D5eDB9dA896a823bFA90A5E483152F6d",
      "0x2a78FEF4610D0F3e20bE18597fd2740E930273e3","0xBe2c6fD365a09c9b552949444685A218751E67Bb","0x6e682225A2E189dB5bFe5B8227436F3B43512f18","0xA56fC35C12cBB3d919FD18748A95622834F43185","0xfbadDE2C9A4Ec2f028c76C91984179a630d3993b","0x264eE8C45237333dE1a1731Ba3D1085F69c096f5","0x11f7d9F08d7b548b0A0Ec8329dE0994FC0c7DBbD","0x9D9C5bF01De826e6835ac9e16792c05f1eb6374F"],
      proof: '',
      root: '',
      mintNum: 1,
      maxSupply: 555,
      mintGasLimit: 22464,
      whitelistMintNum: 1,
      linkAddress: "",
      // whitelistSaleStatus: false,
      // publicSaleStatus: false,
      currentTime: 0,
      currentCount: 146,
      // publicSaleStartTime: 0,
      // whitelistSaleStartTime: 0,
      publicSaleStartTime: 1642251600,
      whitelistSaleStartTime: 1642248000,

      // modal
      modalMessage: "",
      modalStatus: false,
    }
  },
  created() {
    // this.buildIMX();
    const locale = location.pathname.includes('/ja_top') ? 'ja' : 'en'
    this.$i18n.locale = locale
    this.currentTime = parseInt(Date.now() / 1000)

  },
  mounted () {
    let self = this;
    // self.getCurrentCount()
    // this.intervalId = setInterval(function () {
    //   self.getCurrentCount()
    // }, 5000)
  },
  beforeDestroy: function () {
    clearInterval(this.intervalId)
  },
  computed: {
    price: function(){
      return this.isWhitelisted ? 0.05 : 0.05;
    },
    leftSupply: function(){
      return this.maxSupply - this.currentCount;
    },
    isSoldOut: function(){
      return true;
    },
    isWhitelisted: function(){
      return this.lcaseWhitelist.includes(this.walletAddress.toLowerCase())
    },
    lcaseWhitelist: function(){
      return this.whitelist.map(x => x.toLowerCase())
    },
    isWhitelistSaleStarted: function(){
      return this.currentTime >= this.whitelistSaleStartTime;
    },
    isPublicSaleStarted: function(){
      return this.currentTime >= this.publicSaleStartTime;
    },
    linkUrl: function(){
      if(this.railsEnvironment != "production") {
        return 'https://link.ropsten.x.immutable.com'
      } else{
        return 'https://link.x.immutable.com'
      }
    }
  },
  methods: {
    // register and/or setup a user
    linkSetup: async function() {
      if(this.isMobile.phone){
        let result = window.confirm(this.$$.t("mint.usePc"));
        if(!result){
          return false;
        }
      }
      const link = new Link(this.linkUrl);
      // Register user, you can persist address to local storage etc.
      const { address } = await link.setup({});
      console.log("current wallet address", address)
      this.walletAddress = address
      this.linkAddress = address;
    },
    getCurrentCount: async function() {
      // var self = this;
      // axios.get("/api/pre_imx_tx_histories")
      // .then(function(res) {
      //   self.currentCount = res.data.count
      //   console.log(self.currentCount)
      // })
    },

    mint: async function() {
      let self = this;
      console.log("mint initialized")

      if(this.mintNum > this.leftSupply){
        alert("Not enough NFTs left to mint. NFTの在庫が足りません。ミント数を調整お願いします。")
        return
      }

      try{
        if (window.ethereum) {
          try {
            const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });

            if(accounts[0] != this.linkAddress){
              alert(self.$i18n.t("mint.useSameAddress"))
              return 
            }
          } catch (error) {
            if (error.code === 4001) {
              // User rejected request
            }
          }
        }
        const provider = new ethers.providers.Web3Provider(window.ethereum, "any");
        const signer = provider.getSigner();
        const address = await signer.getAddress();

        console.log("signer", signer)
        console.log("address", address)

        // 正しいネットワークかチェック
        const networkId = (await provider.getNetwork()).chainId;
        console.log("networkId", networkId)

        console.log("railsEnvironment", self.railsEnvironment)

        if((self.railsEnvironment == "production" && networkId != 1) || (self.railsEnvironment == "development" && networkId != 3)) {
          alert("Network is incorrect.");
          return;
        }

        const contractAddress = self.railsEnvironment == 'development' ? self.contractAddressForDevelopment : self.contractAddress;        
        console.log("contractAddress", contractAddress)

        const butlersContract = new ethers.Contract(contractAddress, self.contractAbi, signer);

        console.log("butlersContract", butlersContract)
        const override = {
          value: ethers.utils.parseEther((self.mintNum * self.price).toFixed(2).toString()),
          gasLimit: self.mintGasLimit
        }

        console.log("override", override)
        const tx = await butlersContract.mintButler(override);

        axios.post('/api/pre_imx_tx_histories', {purchased_num: self.mintNum})
        alert(self.$i18n.t("mint.success"))
      }catch(e){
        console.log(e)

        alert(self.$i18n.t("mint.fail"));
      }
    },
    reduceNum: function (kind) {
      let self = this;
      if(kind == 'whitelist'){
        if(self.whitelistMintNum <= 1){
          return;
        }
        self.whitelistMintNum -= 1;
      }else{
        if(self.mintNum <= 1){
          return;
        }
        self.mintNum -= 1;
      }
    },
    addNum: function (kind) {
      let self = this;
      if(kind == 'whitelist'){
        self.whitelistMintNum += 1;
      }else{
        if(self.mintNum >= 20 || self.mintNum >= self.leftSupply ){
          return;
        }
        self.mintNum += 1;
      }
    },

    // modal
    openModal: function(errorMessage) {
      this.modalMessage = errorMessage;
      this.modalStatus = true;
    },
    closeModal: function() {
      this.modalStatus = false;
    },
  },
}
</script>

<style scoped lang="scss">
  .shop-wrapper{
    background-size: cover;
    background-position: center;
    // padding: 60px 0;
    // font-family: 'Concert One', cursive;
  }
  .shop{
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 80px 0;
    @media(max-width: 768px){
          display: flex;
          flex-direction: column-reverse;

      padding: 40px 0;
    }
  }
  .shop-image{
    flex-basis: 50%;
    text-align: center;
    img{
      width: 100%;
      // max-width: 450px;
      border-radius: 12px;
      @media(max-width: 768px){
        width: 100%;
      }
    }
  }
  .shop-mint{
    flex-basis: 50%;
    @media(max-width: 768px){
      margin-top: 40px;
    }
  }
  .whitelist-desc{
    font-size: 16px;
    text-align: center;
    color: white;
    // margin-bottom: 40px;
    padding-bottom: 20px;
    a{
      color: white;
      text-decoration: underline;
      &:hover{
        color: white;
        opacity: 0.8;
      }
    }
  }
  .mint-number-wrapper{
    margin: 0 auto;
    max-width: 350px;
    width: 100%;
    background-color: #060606;
    border-radius: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 30px;
  }
  .mint-number-btn{
    padding: 10px 35px;
    background-color: black;
    color: white;
    font-size: 20px;
    text-align: center;
    border-radius: 10px;
    &:hover{
      cursor: pointer;
      opacity: 0.9;
    }
  }
  .mint-number{
    text-align: center;
    font-size: 35px;
    color: black;
  }
  .mint-price{
    font-size: 20px;
    color: white;
    text-align: center;
    margin: 20px 0;
  }
  .mint-btn-wrapper{
    text-align: center;
    margin: 0;
    margin-bottom: 20px;
    &:hover{
      cursor: pointer;
      opacity: 0.9;
    }
  }
  .mint-btn{
    font-weight: 600;
    color: #000!important;
    width: 100%;
    max-width: 350px;
    display: inline-block;
    background-color: white;
    padding: 30px 40px;
    font-size: 22px;
    border-radius: 10px;
    // font-family: 'Concert One', cursive;
  }
  .mint-caution{
    text-align: center;
    font-size: 16px;
    color: white;
    @media(max-width: 768px){
      font-size: 15px;
    }
  }
  .modal-desc{
    color: #000;
  }
</style>
